import { useState } from "react";
import { Download, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { apiError, downloadFile } from "@/lib/api";

/** Whatever is on the screen, taken out as a workbook — same filters, same rows, nothing else. */
export const ExportButton = ({
  path,
  params = {},
  label = "Download Excel",
  testId = "export-button",
  className = "",
}) => {
  const [busy, setBusy] = useState(false);

  const go = async () => {
    setBusy(true);
    try {
      await downloadFile(path, params, "export.xlsx");
      toast.success("Your workbook is ready — it carries exactly what you have on screen.");
    } catch (e) {
      toast.error(apiError(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <button
      type="button"
      data-testid={testId}
      onClick={go}
      disabled={busy}
      className={`flex h-11 items-center gap-2 border border-border bg-card px-4 font-display text-[10px] font-bold uppercase tracking-widest transition-colors duration-200 hover:bg-muted disabled:opacity-50 ${className}`}
    >
      {busy ? (
        <Loader2 className="h-3.5 w-3.5 animate-spin" />
      ) : (
        <Download className="h-3.5 w-3.5" />
      )}
      {label}
    </button>
  );
};
